<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <loading
        :active.sync="loadingMover"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <b-icon class="mt-1" icon="gear"></b-icon>
          <span>CONFIGURACIÓN AVPT (Plan Dental)</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Conf_AVPT</div>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="end">
        <b-col class="col-sm-4">
          <b-form-group align="left" class="mt-2">
            <label>Buscar tratamiento final:</label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                  name="tratamiento"
                  type="text"
                  placeholder="Ingrese un nombre"
                  v-model="nombreTratamiento"
                  @keydown.enter.native="buscarTxFinal"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col align="left">
          <b-button
              variant="outline-info"
              size="sm"
              class="mt-3 mr-5"
              @click="crear()"
          >Crear Nueva Ruta
          </b-button
          >
        </b-col>
      </b-row>

      <div>
        <div class="block">
          <div class="image"><img alt="img" src="@/assets/tablaDental.svg"/></div>
          <div class="content">
            <div align="center" v-if="loaderBusqueda">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div v-if="data != null">
              <b-alert v-if="arbol.length == 0" variant="warning" show
              >No se encontraron resultados
              </b-alert>
            </div>
            <vue-tree-list
                v-if="data != null && arbol.length > 0"
                class="tree"
                :model="data"
                v-bind:default-expanded="true"
            >
              <template v-slot:leafNameDisplay="slotProps">
                <span>

                  {{slotProps.model.orden}} =>
                  <span v-if="slotProps.model.isLeaf">
                    {{ slotProps.model.idTratamiento }}-
                  </span>
                  {{ slotProps.model.name }}

                  <i class="fa fa-hand-o-right ml-1" aria-hidden="true"></i>
<!--                  <span class="ml-2 slots">ID: <span>{{ slotProps.model.id }}</span></span>-->
                  <span class="ml-2 slots" v-if="slotProps.model.pid !== undefined && slotProps.model.pid !== null && slotProps.model.pid !== 0">
                    Tiempo Entre Tx:
                    <span>{{ slotProps.model.tiempoEspera }}</span>
                  </span>

                  <em v-if="slotProps.model.edit"
                      title="Modificar"
                      size="sm"
                      @click="editar(slotProps.model)"
                      class="fa fa-pencil accion"
                  ></em>

                  <em v-if="slotProps.model.drop"
                      title="Eliminar"
                      size="sm"
                      @click="eliminarTxHijo(slotProps.model)"
                      class="fa fa-trash-o accion"
                  ></em>

                  <em v-if="slotProps.model.up && (nombreTratamiento === undefined && nombreTratamiento === null || nombreTratamiento === '')"
                      title="Subir"
                      size="xl"
                      @click="moverNodo(slotProps.model, true)"
                      class="fa fa-sort-asc"
                      style="padding: 5px"
                  ></em>

                  <em v-if="slotProps.model.down && (nombreTratamiento === undefined && nombreTratamiento === null || nombreTratamiento === '')"
                      title="Bajar"
                      size="xl"
                      @click="moverNodo(slotProps.model, false)"
                      class="fa fa-sort-desc"
                      style="padding: 5px"
                  ></em>
                </span>
              </template>
              <template v-slot:treeNodeIcon>
                <span class="icon ml-1 mr-3"
                ><img alt="avpt" src="@/assets/dienteFinal.svg" width="40px"
                /></span>
              </template>
            </vue-tree-list>
          </div>
        </div>
      </div>
      <br/>
      <br/>

      <b-modal
          v-model="showModal"
          :title="titulo"
          size="lg"
          no-close-on-backdrop
      >
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form>
                <b-row>
                  <b-col cols="9">
                    <label class="labels">Tratamiento
                      <validacion/>
                    </label>
                    <v-select
                        label="text"
                        v-model="tratamiento"
                        :options="listaTratamientos"
                        placeholder="--Seleccionar Tratamiento--"
                    >
                      <span slot="no-options">No hay datos...</span>
                    </v-select>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group>
                      <label class="labels">Dias entre Tx
                        <validacion/>
                      </label>
                      <b-form-input
                          type="number"
                          v-model.number="tiempoEspera"
                          aria-describedby="error-ctiempo"
                          min="1"
                          required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" v-if="tratamiento !== undefined && tratamiento !== null">
                    <label>Orden clínico: </label>
                    {{tratamiento.esp}}
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer" class="modal-footer">
          <b-button
              v-if="opcion == 1"
              variant="outline-primary"
              :disabled="loaderAcciones"
              @click="guardarRuta()"
          >
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>

          <b-button
              v-else
              variant="outline-primary"
              :disabled="loaderAcciones"
              @click="guardarEdicion()"
          >
            <span v-if="!loaderAcciones">Modificar</span>
            <span v-if="loaderAcciones">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>

          <b-button
              variant="outline-danger"
              :disabled="loaderAcciones"
              @click="cerrarModal()"
          >Cancelar
          </b-button
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {VueTreeList, Tree} from "vue-tree-list";

export default {
  name: "ConfiguracionAvpt",
  components: {
    Header,
    VueTreeList,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaTratamientos: [],

    form: {
      idTratamiento: null,
      tiempoEspera: null,
      idUsuario: null
    },

    datosEditar: {
      idCavpt: null,
      idTratamiento: null,
      tiempoEspera: null,
      idUsuario: null,
    },

    newTree: {},

    titulo: "",
    data: null,
    json: null,
    arbol: null,
    opcion: null,
    isLeaf: false,
    showModal: false,
    tratamiento: null,
    tiempoEspera: null,
    loaderAcciones: false,
    loaderBusqueda: false,
    nombreTratamiento: null,

    loadingMover: false,
  }),

  created() {
    this.debug = this.$localStorageService.getDebug();
    this.listarTratamientos();
    this.nombreTratamiento = "";
    this.buscarTxFinal();
  },

  methods: {

    moverNodo(nodo, subir) {
      this.loadingMover = true;

      const indicePadre = this.arbol.findIndex(a=>a.id===nodo.pid);
      const indiceHijo = this.arbol[indicePadre].children.findIndex(a=>a.id===nodo.id);

      const indiceSubir = indiceHijo + (subir ? -1 : 1);


      this.arbol[indicePadre].children = this.arbol[indicePadre].children.move(indiceHijo, indiceSubir);

      let i=0;
      this.arbol[indicePadre].children.forEach(arb=>{
        arb.orden = ++i;
      });

      const datosEnviar = this.arbol[indicePadre].children.map(it=> {
        return {
          idCavpt: it.id,
          ordenClinicoEspecialidad: it.orden
        }
      });

      this.$http.put(this.$api + "avpt/editar/orden/tratamientos", datosEnviar)
          .then(() => {
        this.data = new Tree(this.arbol);
      }).catch(() => {
        this.$swal({
          icon: "error",
          text: "A ocurrido un error, intentalo más tarde.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

      }).finally(() => {
        this.loadingMover = false;
      });


    },


    //* Lista catalogos //
    listarTratamientos() {
      this.$http.get(this.$api + "tratamientos/obtener/tx").then((response) => {
        if (response.data.data) {
          const aux = response.data.data;
          aux.forEach((t) => {
            this.listaTratamientos.push({
              value: t.idTratamiento,
              text: t.idTratamiento + '-' + t.nombre,
              esp: t.nombreEspecialidad
            });
          });
        }
      });
    },

    //*Fin catalogos */

    //* Metodos para enviar al back *//

    buscarTxFinal() {
      this.loaderBusqueda = true;
      this.data = null;
      this.$http
          .get(
              this.$api +
              "avpt/obtenerRuta?nombreTratamiento=" +
              this.nombreTratamiento
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              const datos = respuesta.data.data;
              this.arbol = [];

              //obtengo los padre
              let nodosOrdenClinico = [];
              datos.forEach((p) => {
                let nodo = {
                  id: p.nombreEspecialidad,
                  name: p.nombreEspecialidad,
                  orden: p.ordenClinicoEspecialidad,
                  edit: false,
                  drop: false,
                  isLeaf: false,
                  dragDisabled: true,
                  addTreeNodeDisabled: true,
                  addLeafNodeDisabled: true,
                  editNodeDisabled: true,
                  delNodeDisabled: true,
                };
                nodosOrdenClinico.push(nodo);
              });

              //quito duplicados y ordeno por orden clinico adulto
              const nodosOrdenClinicoUnico = new Set( nodosOrdenClinico.map( JSON.stringify ) );
              this.arbol = Array.from( nodosOrdenClinicoUnico ).map( JSON.parse ).sort(function(a, b) {
                return a.orden - b.orden;
              });

              //recorrer el arbol y voy a meter los hijos y a ordenarlos
              this.arbol.forEach(arb=> {
                const trats = datos.filter(dat=>dat.ordenClinicoEspecialidad === arb.orden)
                    .map(dat=>{
                      return {
                        id: dat.idCavpt,
                        idTratamiento: dat.idTratamiento,
                        name: dat.nombreTratamiento,
                        orden: dat.orden,
                        edit: true,
                        drop: true,
                        up: true,
                        down: true,
                        tiempoEspera: dat.tiempoEspera,
                        isLeaf: false,
                        dragDisabled: true,
                        addTreeNodeDisabled: true,
                        addLeafNodeDisabled: true,
                        editNodeDisabled: true,
                        delNodeDisabled: true,
                        pid: arb.id
                      };
                    });

                    //orden clinico adulto
                    let nodosOrdenClinicoUnicoTmp = new Set( trats.map( JSON.stringify ) );
                    nodosOrdenClinicoUnicoTmp = Array.from( nodosOrdenClinicoUnicoTmp ).map( JSON.parse ).sort(function(a, b) {
                      return a.orden - b.orden;
                    });

                arb.children = nodosOrdenClinicoUnicoTmp;
              });

              this.data = new Tree(this.arbol);
            }
          })
          .finally(() => {
            this.loaderBusqueda = false;
          });
    },

    guardarRuta() {
      if (this.tratamiento.value == null) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione un tratamiento",
        });
        return false;
      }
      if (this.tiempoEspera < 1) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Los días no deben ser negativos ni tampoco 0",
        });

        return false;
      }

      this.form.idTratamiento = this.tratamiento.value;
      this.form.tiempoEspera = this.tiempoEspera;
      this.form.idUsuario = this.$localStorageService.getIdUsuario();
      this.loaderAcciones = true;
      this.$http
          .post(this.$api + "avpt/crear/ruta/tratamientoFinal", this.form)
          .then((response) => {
            if (response.data.data) {
              this.nombreTratamiento = "";
              this.$swal({
                icon: "success",
                text: "Datos guardados correctamente.",
                showConfirmButton: false,
                timer: 1500,
              });
              this.buscarTxFinal();
              this.cerrarModal();
            } else {
              this.$swal({
                icon: "error",
                text: "No se pudo guardar, verifique datos ingresados",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            }
          })
          .catch((error) => {
            var message = error.response.data.message
                ? error.response.data.message
                : "A ocurrido un error, intentalo más tarde.";
            this.$swal({
              icon: "error",
              text: message,
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => (this.loaderAcciones = false));
    },

    guardarEdicion() {
      this.datosEditar.idTratamiento = this.tratamiento.value;
      this.datosEditar.tiempoEspera = this.tiempoEspera;
      this.datosEditar.idUsuario = this.$localStorageService.getIdUsuario();

      if (this.datosEditar.tiempoEspera < 1) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Los días no deben ser negativos ni tampoco 0",
        });

        return false;
      }

      if (
          this.datosEditar.tiempoEspera == null ||
          this.datosEditar.idTratamiento == null
      ) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Todos los campos son requeridos",
        });

        return false;
      }

      this.loaderAcciones = true;
      this.$http
          .post(this.$api + "avpt/editar/tratamiento/cavpt", this.datosEditar)
          .then((response) => {
            if (response.data.data == true) {
              this.nombreTratamiento = "";
              this.$swal({
                icon: "success",
                text: "Datos modificados correctamente",
                showConfirmButton: false,
                timer: 1500,
              });
              this.buscarTxFinal();
              this.cerrarModal();
            } else {
              this.$swal({
                icon: "error",
                text: "No se pudo editar, verifique datos ingresados",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            }
          })
          .catch((error) => {
            var message = error.response.data.message
                ? error.response.data.message
                : "A ocurrido un error, intentalo más tarde.";
            this.$swal({
              icon: "error",
              text: message,
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => (this.loaderAcciones = false));
    },

    eliminarTxHijo(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de quitar el tratamiento?",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idCavpt: item.id,
          }
          this.$http
              .post(this.$api + "avpt/eliminar/txHijo", parametros)
              .then((respuesta) => {
                if (respuesta.data.data) {
                  this.nombreTratamiento = "";
                  this.buscarTxFinal();
                  this.$swal.fire({
                    icon: "success",
                    position: "top-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 3000,
                    text: "El tratamiento se quito correctamente",
                  });
                }
              });
        }
      });
    },

    //* Fin metodos para enviar al back */

    //* Metodos para modales *//

    crear() {
      this.limpiarFormulario();
      this.titulo = "Crear Ruta de Tratamientos";
      this.opcion = 1;
      this.showModal = true;
    },

    editar(params) {
      this.tratamiento = this.listaTratamientos.find(it=>it.value === params.idTratamiento);
      this.tiempoEspera = params.tiempoEspera;
      this.datosEditar.idCavpt = params.id;
      this.opcion = 2
      this.showModal = true;
      this.titulo = "Modificar Tratamiento";
    },

    limpiarFormulario() {
      (this.form = {
        idTratamiento: null,
        idCAvptPadre: null,
        tiempoEspera: null,
        idUsuario: null,
        children: [],
      });

      this.datosEditar = {
        idCavpt: null,
        idTratamiento: null,
        idCavptPadre: null,
        tiempoEspera: null,
        idUsuario: null,
      };

      this.tratamiento = null;
      this.tiempoEspera = null;
    },

    cerrarModal() {
      this.showModal = false;
      this.limpiarFormulario();
    },
  }
};
</script>

<style scoped>
.slots {
  color: rgb(129, 45, 45);
  font-size: 80%;
}

.slots span {
  color: black;
}

.block {
  text-align: center;
  margin-top: 40px;
  border-radius: 25px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px,
  rgba(0, 0, 0, 0.05) 0px 5px 10px;
}

.block .image {
  position: relative;
  border-radius: 50%;
  margin: auto;
  background-color: rgb(247, 247, 247);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em,
  rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em,
  rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
}

.block .image {
  top: -32px;
  width: 64px;
  height: 64px;
}

.block .image img {
  padding: 8px;
}

.tree {
  padding: 0 15px 20px;
}

.accion {
  margin-left: 10px;
  color: rgb(117, 100, 5);
  cursor: pointer;
}

.eliminar {
  margin-top: 33px;
  height: 40px;
}

.labels {
  font-size: 13px;
}

.modal-footer {
  margin: 0 auto;
}

.search {
  font-size: 2px;
}

.btn-save {
  position: sticky;
  bottom: 12px;
  margin-top: 15px;
  background-color: #fff;
  color: #098d33;
  font-size: 22px;
  border-radius: 50px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
  z-index: 100;
}

.btn-save:hover {
  text-decoration: none;
  background-color: #098d33;
  color: #fff;
}

.spiner {
  position: sticky;
  bottom: 12px;
  margin-top: 15px;
}
</style>
